import { buildModuleWrapperId } from './classNameUtils';
import { isStyleOverridden, lookupCssValue, writeGridPositionToCss, writePadding } from './gridLayoutStyleUtils';
import { buildNodeSelector, isMediaQuery } from './combineBreakpointStyles';
import { isFitContentWidth, isSizedWidth } from 'layout-data-lib/GridLayoutDataTree/typenameUtils';
function writeEditorProvidedModuleStylesToCss(styles, stylesByBreakpointName) {
  Object.entries(styles.breakpointStyles).forEach(([breakpointName, style]) => {
    const stylesForBreakpoint = stylesByBreakpointName[breakpointName] || [];
    if (!stylesByBreakpointName[breakpointName]) {
      stylesByBreakpointName[breakpointName] = stylesForBreakpoint;
    }
    if (isStyleOverridden(style.gridPosition) || isStyleOverridden(style.gridSpanning)) {
      stylesForBreakpoint.push(writeGridPositionToCss(style.gridPosition, style.gridSpanning));
    }
    if (isStyleOverridden(style.flexGrow)) {
      stylesForBreakpoint.push(`flex-grow: ${style.flexGrow};`);
      stylesForBreakpoint.push(`flex-basis: 0;`);
    } else if (isStyleOverridden(style.width)) {
      if (isSizedWidth(style.width)) {
        stylesForBreakpoint.push(`width: ${style.width.size.value}${lookupCssValue(style.width.size.units)};`);
      } else if (isFitContentWidth(style.width)) {
        stylesForBreakpoint.push(`width: fit-content;`);
      }
    }
    if (isStyleOverridden(style.isHidden)) {
      stylesForBreakpoint.push(`display: ${style.isHidden ? 'none' : 'block'};`);
    }
    if (isStyleOverridden(style.padding)) {
      stylesForBreakpoint.push(writePadding(style.padding));
    }
    stylesByBreakpointName[breakpointName] = stylesForBreakpoint;
  });
  return stylesByBreakpointName;
}
export default function writeModuleStylesToCss(nodeId, styles, breakpointConfigs) {
  const editorProvidedStyles = styles.editorProvidedModuleBreakpointStyles;
  if (!editorProvidedStyles) {
    return [];
  }
  const moduleWrapperSelector = buildModuleWrapperId(nodeId);
  const stylesByBreakpointName = {};
  writeEditorProvidedModuleStylesToCss(editorProvidedStyles, stylesByBreakpointName);
  return breakpointConfigs.map(config => {
    const {
      breakpointName
    } = config;
    const breakpointStyles = stylesByBreakpointName[breakpointName];
    if (!breakpointStyles || breakpointStyles.length === 0) {
      return null;
    }
    const selector = buildNodeSelector({
      targetSelector: `#${moduleWrapperSelector}`,
      breakpointConfig: config
    });
    const mediaQuery = isMediaQuery(config) ? config.mediaQuery : '';
    return [selector, breakpointStyles.join(' '), mediaQuery];
  }).filter(triple => triple !== null);
}